import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router/index.ts';
import './style.css';

// 创建 Vue 应用
const app = createApp(App);

// 使用路由和状态管理
app.use(createPinia());
app.use(router);

// 挂载应用
app.mount('#app');
